import { render } from "./RiArrowUp.vue?vue&type=template&id=a48b3f72"
import script from "./RiArrowUp.vue?vue&type=script&lang=js"
export * from "./RiArrowUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiArrowUp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a48b3f72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a48b3f72', __exports__)) {
    api.reload('a48b3f72', __exports__)
  }
  
  module.hot.accept("./RiArrowUp.vue?vue&type=template&id=a48b3f72", () => {
    api.rerender('a48b3f72', render)
  })

}


export default __exports__